import Vue from "vue";
import Component from "vue-class-component";

@Component({
	props: {
		closeOnEscapeKeyDown: {
			type: Boolean,
			default: true
		}
	}
})
class Closable extends Vue {
	constructor() {
		super();
	}

	mounted() {
		if (this.closeOnEscapeKeyDown) {
			this.keydown.bind(this);
			window.addEventListener("keydown", this.keydown);
		}
	}

	beforeDestroy() {
		if (this.closeOnEscapeKeyDown)
			window.removeEventListener("keydown", this.keydown);
	}

	close(e) {
		this.$emit("close", e);
	}

	keydown(ev) {
		if (ev.keyCode == 27 && this.closeOnEscapeKeyDown) this.close();
	}
}
export default Closable;
